import { ToastColor, ToastPosition } from '../enums';

export interface IToastConfig {
    icon?: string;
    color?: ToastColor;
    title?: string;
    message: string;
    description?: string;
    position?: ToastPosition;
    duration?: number;
    extraClasses?: string;
    action?: {
        label?: string;
        icon?: string;
        callback: () => void;
    };
}
